/** @jsxImportSource solid-js */
import { classes } from "#palette/style/index.solid";

function ProgressItem(props: { color: string }) {
  return <div class={classes(["w-full h-5 rounded-xl", props.color])} />;
}

export function Progressbar(props: {
  segments: number;
  complete: number;
  currentColor?: string;
  completeColor?: string;
  upcomingColor?: string;
}) {
  const theseSegments: JSX.Element[] = [];
  const actualCurrentColor = props.currentColor ?? "bg-brand-900";
  const actualCompleteColor = props.completeColor ?? "bg-brand-500";
  const actualUpcomingColor = props.upcomingColor ?? "bg-brand-50";

  for (let n = 0; n < props.segments; n++) {
    const color =
      n === props.complete - 1
        ? actualCurrentColor
        : n < props.complete
          ? actualCompleteColor
          : actualUpcomingColor;
    theseSegments.push(<ProgressItem color={color} />);
  }

  return (
    <div class="mb-5 flex gap-5 justify-between">
      {theseSegments.map((s) => s)}
    </div>
  );
}
